import { CreateButton } from '@/components';
import type { FC } from 'react';
import { type TableType, useDrawerState } from './DrawerStateProvider';

type Props = {
  type: TableType;
};

export const CreateMasterTableButton: FC<Props> = ({ type }) => {
  const { setDrawerState } = useDrawerState();
  return (
    <CreateButton
      onCreate={() => {
        setDrawerState({ open: true, type, isEditing: false });
      }}
    />
  );
};
